/* eslint-disable max-lines-per-function */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/default */
/* eslint-disable import/namespace */

import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './styles.css';
import { Button } from 'primereact/button';
import { SlideMenu } from 'primereact/slidemenu';
import 'primeflex/primeflex.css';
import Layout from '../layout';
import MeuLink from '../../components/meuLink';
import MeusDados from '../../components/meusDados';
import EditarPerfil from '../../components/editarPerfil';
import Vendas from '../../components/vendas';
import ModificarSenha from '../../components/modificar-senha';
import { Buscar } from '../../services/perfis';
import { Menu } from 'primereact/menu';
import { PanelMenu } from 'primereact/panelmenu';
import ListaContratos from '../../components/listaContratos';
import { ContratosAtraso } from '../../components/contratos-atraso';
import { ContratosEntregues } from '../../components/contratos-entregues';
import { ContratosRecebidos } from '../../components/contratos-recebidos';
import CadastrarContratos from '../../components/cadastrar-contratos';
import Pdf from '../../components/pdf/index';
import NiverAssociados from '../../components/niverAssociado/index';
import Pagamento from '../../components/pagamento';
import CadastrarDependentes from '../../components/cadastrar-dependentes';
import Assinatura from '../../components/assinatura';
import graficoCompras from '../../components/graphsCompras/index';
import graficoComprasCoordenador from '../../components/graphsComprasCoordenador';
import graficoComprasGerente from '../../components/graphsComprasGerente/index';
import Finalizacao from '../../components/finalizacaoBackup/index';
import { setUser } from '../../modulos/setUser/setUser';
import editarAssociados from '../../components/editForm/index';
import MensagemAbertura from '../../components/mensagem-abertura/index';
import {
    getIconeByPermissao,
    getMenu,
    getMenuPerfisPossiveis
} from '../../services/sistema/menu_portal';
import VisualizaAssociado from '../../components/visualizaAssoc/index';
import Avisos from '../../components/avisos/index';
import { showMessageError, showMessageAlert } from '../../components/others/toastr';
import 'toastr/build/toastr.min.js';
import 'toastr/build/toastr.css';
import TabelaPreco from '../../components/tabelaPreco/index.jsx';
import TabelaEdicaoPreco from '../../components/tabelaEdicaoPreco/index';
import Relatorios from '../../components/relatorio-comissoes/index';
import RelatorioGerente from '../../components/relatorio-comissoes/gerente';
import Ajuda from '../../components/ajuda';
import { FiAlertTriangle } from 'react-icons/fi';
import AvisoNovo from '../../components/aviso-novo';
import CadastrarDocumentos from '../../components/cadastrarDocumentos';
import CobrancaAssociado from '../../components/cobranca-associado';
import cadastroEdicaoPrecosLote from '../../components/cadastro-edicao-precos-lote';
import RegularPagamentos from '../../components/regular-pagamento';
import RegularPagamentosBloqueados from '../../components/regular-pagamentos-bloqueados';
import { UploadMidias } from '../../components/tvs/upload-midias';
import { CadastrarGruposTVs } from '../../components/tvs/cadastrar-grupos-tvs';
import { CadastrarTvs } from '../../components/tvs/cadastrar-tvs';
import ManutencaoLinks from '../../components/tvs/links';
import CadastrarServicosAdicionais from '../../components/cadastrar-servicos-adicionais';
import { criptoLocalStorage, decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import CadastroEdicaoPrecosMensalidadeLote from '../../components/cadastro-edicao-precos-mensalidade-lote';
import { ProgressSpinner } from 'primereact/progressspinner';
import { buscaUsrPermissaoUpSell } from '../../services/upSell/index.js';
import ListarUpSell from '../../components/upSell/index.js';
import getTipoColaborador from '../../helpers/getTipoColaborador.js';
import TelaComparativo from '../../components/upSell/TelaComparativo/index.js';
import Bonificacao from '../../components/tabelaEdicaoPreco/bonificacao/index.js';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            time: 3000,
            numeroDois: 2,
            nome: '',
            link: '',
            items: [],
            mensagem: '',
            perfilAtual: '1',
            itemsMenuHeader: [
                {
                    label: decriptoLocalStorage('Nome')?.decriptoValue ?
                        decriptoLocalStorage('Nome')?.decriptoValue :
                        '',
                    icon: getIconeByPermissao(decriptObjectOnLocalStorage('PERM')),
                    items: getMenuPerfisPossiveis()
                }
            ]
        };

        this.permissao = decriptoLocalStorage('PERM').decriptoValue;

        this.items = [
            {
                label: 'Options',
                items: [
                    {
                        label: 'Update',
                        icon: 'pi pi-refresh',
                        command: () => {
                            this.toast.show({
                                severity: 'success',
                                summary: 'Updated',
                                detail: 'Data Updated',
                                life: 3000
                            });
                        }
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-times',
                        command: () => {
                            this.toast.show({
                                severity: 'warn',
                                summary: 'Delete',
                                detail: 'Data Deleted',
                                life: 3000
                            });
                        }
                    }
                ]
            },
            {
                label: 'Navigate',
                items: [
                    {
                        label: 'React Website',
                        icon: 'pi pi-external-link',
                        url: 'https://reactjs.org/'
                    },
                    {
                        label: 'Router',
                        icon: 'pi pi-upload',
                        command: _e => {
                            window.location.hash = '/fileupload';
                        }
                    }
                ]
            }
        ];
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });

            const [response, resultMenu] = await Promise.all([Buscar(this.permissao), getMenu()]);

            const usuarioSupervisor = decriptoLocalStorage('USRSUP')?.decriptoValue;
            const usuarioCoordenador = decriptoLocalStorage('USRCOO')?.decriptoValue;

            if (response.Status === 'I' && !usuarioSupervisor && !usuarioCoordenador) {
                showMessageAlert('O Colaborador está inativo!');
                showMessageError('Retornando a pagina de login.');

                return (this.timer = setInterval(() => this.logout(), this.state.time));
            }

            setUser(response);
            this.setState({
                nome: response.Nome,
                link: response.Link
            });
            this.setState({
                itemsMenuHeader: [
                    {
                        label: decriptoLocalStorage('Nome')?.decriptoValue ?
                            decriptoLocalStorage('Nome')?.decriptoValue :
                            '',
                        icon: getIconeByPermissao(decriptObjectOnLocalStorage('PERM')),
                        items: getMenuPerfisPossiveis()
                    }
                ]
            });

            const tipoColaborador = getTipoColaborador(this.permissao);

            let itemsMenu = resultMenu;

            const verificarPermissaoUpSell = async (codigo, tipo) => {
                const permissaoUpSell = decriptoLocalStorage('mostrar_upSell')?.decriptoValue;

                if (permissaoUpSell === undefined) {
                    const permissaoListarUpSell = await buscaUsrPermissaoUpSell({
                        codigo,
                        tipo
                    });

                    const mostrarUpSell = permissaoListarUpSell?.status;

                    criptoLocalStorage('mostrar_upSell', String(mostrarUpSell));

                    return mostrarUpSell;
                }

                return permissaoUpSell === 'true';
            };

            const mostrarUpSell = await verificarPermissaoUpSell(response.codigo, tipoColaborador);

            if (!mostrarUpSell) {
                itemsMenu = itemsMenu.filter(item => item.label !== 'Up Sell');
            }

            const itemPositionArrayDelete = 3;
            const itemPositionArray = 0;

            if (decriptoLocalStorage('area')?.decriptoValue ===
                '3' && decriptoLocalStorage('perfilPossivel')?.decriptoValue ===
                '1' && decriptObjectOnLocalStorage('PERM')?.decriptoValue ===
                '1') {
                delete itemsMenu[itemPositionArrayDelete].items[itemPositionArray];
            }

            if (itemsMenu.length > itemPositionArray) {
                this.setState({ items: itemsMenu });
            } else {
                this.setState({
                    items: [
                        {
                            label: 'Erro ao carregar menu',
                            icon: 'pi pi-fw pi-pencil',
                            url: '/'
                        }
                    ]
                });
            }
        } catch (error) {
            this.setState({
                items: [
                    {
                        label: 'Erro ao carregar menu',
                        icon: 'pi pi-fw pi-pencil',
                        url: '/'
                    }
                ]
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        this.setState({ nome: decriptoLocalStorage('Nome')?.decriptoValue });
    }

    logout() {
        localStorage.removeItem('TOKEN');
        window.location.reload();
        localStorage.clear();
        sessionStorage.clear();
    }

    isLoading() {
        return <div>
            <ProgressSpinner
                className='isLoading'
                strokeWidth="1"
                fill="#EEEEEE"
                animationDuration=".5s"
            />
        </div>;
    }

    switchRoutes() {
        switch (this.permissao) {
            case '1':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoCompras : this.isLoading} />
                        <Route exact path="/layout" component={Layout} />
                        <Route exact path="/meus-dados" component={MeusDados} />
                        <Route exact path="/editar-perfil" component={EditarPerfil} />
                        <Route exact path="/vendas" component={Vendas} />
                        <Route exact path="/up-sell" component={ListarUpSell} />
                        <Route exact path="/up-sell/comparativo/:inscricao" component={TelaComparativo} />
                        <Route
                            exact
                            path="/meu-link"
                            component={MeuLink}
                            link={this.state.nome}
                        />
                        <Route
                            exact
                            path="/modificar-senha"
                            component={ModificarSenha}
                        />
                        <Route
                            exact
                            path="/lista-contratos"
                            component={ListaContratos}
                        />
                        <Route
                            exact
                            path="/contratos-atraso"
                            component={ContratosAtraso}
                        />
                        <Route
                            exact
                            path="/contratos-entregues"
                            component={ContratosEntregues}
                        />
                        <Route
                            exact
                            path="/contratos-recebidos"
                            component={ContratosRecebidos}
                        />
                        <Route
                            exact
                            path="/cadastrar-contratos"
                            component={CadastrarContratos}
                        />
                        <Route exact path="/pdf" component={Pdf} />
                        <Route
                            exact
                            path="/cadastrar-dependentes/:inscricao"
                            component={CadastrarDependentes}
                        />
                        <Route
                            exact
                            path="/cadastrar-servicos-adicionais/:inscricao"
                            component={CadastrarServicosAdicionais}
                        />
                        <Route
                            exact
                            path="/cadastrar-documentos/:inscricao"
                            component={CadastrarDocumentos}
                        />
                        <Route exact path="/associadosn" component={NiverAssociados} />
                        <Route
                            exact
                            path="/assinatura/:inscricao"
                            component={Assinatura}
                        />
                        <Route
                            exact
                            path="/pagamento/:inscricao"
                            component={Pagamento}
                        />
                        <Route
                            exact
                            path="/finalizacao/:inscricao"
                            component={Finalizacao}
                        />
                        <Route
                            exact
                            path="/editar-contrato/:inscricao"
                            component={editarAssociados}
                        />
                        <Route
                            exact
                            path="/mensagem-abertura"
                            component={MensagemAbertura}
                        />
                        <Route exact path="/avisos" component={Avisos} />
                        <Route exact path="/tabela-Preco" component={TabelaPreco} />
                        <Route exact path="/relatorio" component={Relatorios} />
                        <Route exact path="/ajuda" component={Ajuda} />
                    </Switch>
                );
            case '2':
            case '3':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoComprasCoordenador : this.isLoading} />
                        <Route exact path="/meus-dados" component={MeusDados} />
                        <Route
                            exact
                            path="/lista-contratos"
                            component={ListaContratos}
                        />
                        <Route
                            exact
                            path="/visualizar-assoc/:inscricao"
                            component={VisualizaAssociado}
                        />
                        <Route exact path="/avisos" component={Avisos} />
                        <Route exact path="/tabela-Preco" component={TabelaPreco} />
                        <Route exact path="/relatorio" component={Relatorios} />
                        <Route exact path="/ajuda" component={Ajuda} />{' '}
                    </Switch>
                );
            case '5':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoCompras : this.isLoading} />
                        <Route exact path="/meus-dados" component={MeusDados} />
                        <Route exact path="/regular-pagamentos" component={RegularPagamentos} />
                        <Route exact path="/regular-pagamentos-bloqueados" component={RegularPagamentosBloqueados} />
                    </Switch>
                );
            case '7':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoComprasGerente : this.isLoading} />
                        <Route
                            exact
                            path="/lista-contratos"
                            component={ListaContratos}
                        />
                        <Route exact path="/avisos" component={Avisos} />
                        <Route
                            exact
                            path="/cadastro-edicao-precos"
                            component={cadastroEdicaoPrecosLote}
                        />
                        <Route
                            exact
                            path="/cadastro-edicao-precos-mensalidades"
                            component={CadastroEdicaoPrecosMensalidadeLote}
                        />
                        <Route
                            exact
                            path="/visualizar-assoc/:inscricao"
                            component={VisualizaAssociado}
                        />
                        <Route
                            exact
                            path="/editar-tabela-preco"
                            component={TabelaEdicaoPreco}
                        />
                        <Route exact path="/bonificacao" component={Bonificacao} />

                        <Route exact path="/relatorio" component={Relatorios} />
                        <Route
                            exact
                            path="/relatorioGerente"
                            component={RelatorioGerente}
                        />
                        <Route exact path="/ajuda" component={Ajuda} />
                    </Switch>
                );
            case '8':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoComprasGerente : this.isLoading} />
                        <Route
                            exact
                            path="/lista-contratos"
                            component={ListaContratos}
                        />
                        <Route exact path="/avisos" component={Avisos} />
                        <Route exact path="/tabela-Preco" component={TabelaPreco} />
                        <Route
                            exact
                            path="/visualizar-assoc/:inscricao"
                            component={VisualizaAssociado}
                        />
                        <Route exact path="/relatorio" component={Relatorios} />
                        <Route
                            exact
                            path="/relatorioGerente"
                            component={RelatorioGerente}
                        />
                        <Route exact path="/ajuda" component={Ajuda} />
                    </Switch>
                );
            case '10':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoCompras : this.isLoading} />
                        <Route
                            exact
                            path="/upload-midias"
                            component={UploadMidias}
                        />
                        <Route
                            exact
                            path="/cadastrar-links"
                            component={ManutencaoLinks}
                        />
                        <Route
                            exact
                            path="/cadastrar-grupos"
                            component={CadastrarGruposTVs}

                        />
                        <Route
                            exact
                            path="/cadastrar-tvs"
                            component={CadastrarTvs}

                        />
                    </Switch>
                );

            case '12':
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoComprasGerente : this.isLoading} />
                        <Route
                            exact
                            path="/lista-contratos"
                            component={ListaContratos}
                        />
                        <Route
                            exact
                            path="/visualizar-assoc/:inscricao"
                            component={VisualizaAssociado}
                        />
                        <Route
                            exact
                            path="/cobranca-assoc/:inscricao"
                            component={CobrancaAssociado}
                        />
                        <Route
                            exact
                            path="/regular-pagamentos"
                            component={RegularPagamentos}
                        />
                        <Route
                            exact
                            path="/regular-pagamentos-bloqueados"
                            component={RegularPagamentosBloqueados}
                        />

                        <Route exact path="/ajuda" component={Ajuda} />
                    </Switch>
                );
            default:
                return (
                    <Switch>
                        <Route exact path="/" component={!this.state.isLoading ? graficoCompras : this.isLoading} />
                        <Route exact path="/meus-dados" component={MeusDados} />
                    </Switch>
                );
        }
    }

    render() {
        return (
            <>
                <div className="main-container">

                    <AvisoNovo />
                    {this.state.mensagem ? <MensagemAbertura /> : ''}
                    <header className="responsive-header">
                        <ul className="itens-menu" id="nav">
                            <li style={{ zIndex: 10 }}>
                                <PanelMenu
                                    className="p-button-secondary"
                                    model={this.state.itemsMenuHeader}
                                    style={{ width: 'auto' }}
                                />
                            </li>
                        </ul>
                    </header>
                    <div className="p-grid">
                        <div>
                            <div className="card wrap2">
                                <Menu
                                    model={this.state.items}
                                    popup
                                    ref={el => (this.menu = el)}
                                    id="popup_menu"
                                />
                                <Button
                                    label="Menu"
                                    icon="pi pi-bars"
                                    onClick={event => this.menu.toggle(event)}
                                    aria-controls="popup_menu"
                                    aria-haspopup
                                    style={{
                                        width: '80px',
                                        height: '40px',
                                        marginLeft: '15px',
                                        marginTop: '15px'
                                    }}
                                />
                            </div>
                        </div>
                        <div className="contentMenu wrap">
                            <div className="p-col-fixed">
                                <SlideMenu
                                    model={this.state.items}
                                    viewportHeight={380}
                                    style={{
                                        height: '600px',
                                        width: '200px'
                                    }}
                                ></SlideMenu>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-7 p-lg-10">
                            <br />
                            <div className="content">
                                <BrowserRouter>{this.switchRoutes()}</BrowserRouter>
                            </div>
                        </div>
                    </div>

                    <footer>
                        <p className="textHF">Todos direitos reservados - Grupo Zelo</p>
                    </footer>
                </div>
                {window.location.href.split('/')[this.state.numeroDois] === 'vendasteste.grupozelo.com' && (
                    <div className="ambiente-testes">
                        <div className="icon-ambiente-testes">
                            <FiAlertTriangle size={40} />
                        </div>
                        <div className="content-ambiente-testes">
                            <h2>Ambiente de testes</h2>
                            <p>
                                Esse ambiente serve apenas para testes, nenhuma operação
                                será realizada de fato.
                            </p>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default Home;
